'use client';

import { useLivestream } from './FloatingLivestreamProvider';

/**
 * The way back to a dismissed stream.
 *
 * Only renders while a stream is live and the card is closed — so it is never
 * redundant with the player itself.
 *
 * Adapted from tradex-platform's LiveStreamPill.tsx, restyled to this
 * project's design tokens.
 */
export default function LiveStreamPill() {
  const { live, isOpen, open } = useLivestream();

  if (!live || isOpen) return null;

  return (
    <button
      type="button"
      onClick={open}
      title={live.channelLabel}
      aria-label={`Open livestream: ${live.channelLabel}`}
      // Sized in this project's rem (1rem = 8px at the design width), matching the
      // LIVE pill in the card header of Figma node 9293:13323.
      className="flex shrink-0 items-center gap-[0.75rem] rounded-[5rem] border border-solid border-red-500/40 bg-red-500/10 px-[1.25rem] py-[0.625rem] font-geist text-[1.5rem] font-semibold uppercase leading-[1.5rem] tracking-[0.03rem] text-red-500 transition-colors hover:bg-red-500/20"
    >
      <span className="h-[0.75rem] w-[0.75rem] rounded-full bg-[#ff3b3b]" aria-hidden />
      LIVE
    </button>
  );
}
